import React from "react";
import { LazyLoadComponent } from "react-lazy-load-image-component";

import Header from "../../global/header";
import HeroMain from "../../global/heroMain";
import ServicesSlider from "../../global/servicesSlider";
import NewService from "../../global/newService";
import VisualStory from "../../global/visualStory";
import PageList from "./pageList";
import PageSection from "./pageSection";
import PageContactFormGeneric from "./pageContactFormGeneric";
import PageStepScreenshots from "./pageStepScreenshots";
import ConsultationRates from "../../global/consultationRates";
import Sponsors from "../../global/sponsors";
import NewPopularArticles from "../../global/newPopularArticles";
import ContactFormChronic from "../../global/contactFormChronic";
import ContactFormChronicV2 from "../../global/contactFormChronicV2";
import ContactFormEmail from "../../global/contactFormEmail";
import ContactFormTime from "../../global/contactFormTime";
import ContactFormMensHealth from "../../global/contactFormMensHealth";
import ContactFormImage from "../../global/contactFormImage";
import ContactForm from "../../global/contactForm";
import StaticPackageDetails from "../../global/staticPackageDetails";
import HeroSlider from "../../global/heroSlider";
import Subtitle from "../../global/subtitle";
import ConditionCards from "../../global/conditionCards";
import SliderSection from "../../global/sliderSection";
import Ministry from "../../global/ministry";
import InlineList from "../../global/inlineList";
import SimpleParagraphs from "../../global/simpleParagraphs";
import TableSection from "../../global/tableSection";
import SectionList from "../../global/sectionList";
import VaccinationSection from "../../global/vaccinationSection";
import BenefitsDropdown from "../../global/benefitsDropdown";
import DropdownDetails from "../../global/dropdownDetails";
import ChronicPackagesDetails from "../../global/chronicPackagesDetails";
import PackageModules from "../../global/packageModules";
import Policy from "../../global/policy";
import DownloadMobileApps from "../../global/downloadMobileApps";
import Margin from "../../global/margin";
import DropdownCards from "../../global/dropdownCards";
import PartnerCta from "../../global/partnerCta";
import ServiceShowcases from "../../global/serviceShowcases";
import StaffShowcase from "../../global/staffShowcase";
import LatestUpdates from "../../global/latestUpdates";
import MediaMentions from "../../global/mediaMentions";
import TripleInfo from "../../global/tripleInfo";
import GetApp from "../../global/getApp";
import CaseStudies from "../../global/caseStudies";
import Marquee from "../../global/marquee";
import LogoBanner from "../../global/logoBanner";
import ServiceBundles from "../../global/serviceBundles";
import EntriesSection from "../../global/entriesSection";
import DataModule from "../../global/dataModule";
import ArticleDataSection from "../../global/articleDataSection";
import FeatureSection from "../../global/featureSection";
import PanelsTable from "../../global/panelsTable";
import MobileAppShowcase from "../../global/mobileAppShowcase";
import BlogCardsSection from "../../global/blogCardsSection";
import PressroomCardsSection from "../../global/pressroomCardsSection";
import SurveySection from "../../global/surveySection";
import JotForm from "../../global/jotForm";
import JoinUs from "../../global/joinUs";
import JoinUsV2 from "../../global/joinUsV2";
import DownloadAppV4 from "../../global/downloadAppV4";
import OurServices from "../../global/ourServices";
import Testimonials from "../../global/testimonials";
import Tile from "../../global/tile";
import BusinessPartner from "../../global/businessPartner";
import HeroComponentV4 from "../../global/heroV4";
import FAQs from "../../global/faqs";
import MiniCta from "../../global/miniCta";
import HouseCallDoctor from "../../global/houseCallDoctor";
import WhyBookHouseCallDoctor from "../../global/whyBookHouseCallDoctor";
import DynamicBookingForm from "../../global/dynamicBookingForm";
import SymptomSearch from "../../global/symptomSearch";
import ComponentSplitting from "../../global/componentSplitting";
import TypeOfCare from "../../global/typeOfCare";
import HeroCall from "../../global/heroCall";
import HeroFlat from "../../global/heroFlat";
import ArticleListView from "../../global/articleListView";
import AmbulancePartners from "../../global/ambulancePartners";
import ProgrammeFeature from "../../global/programmeFeature";
import OurPartnersMini from "../../global/ourPartnersMini";
import FeaturedText from "../../global/featuredText";
import HeroForm from "../../global/heroForm";
import ImageTextFlexAlign from "../../global/imageTextFlexAlign";
import FeaturedQuote from "../../global/featuredQuote";
import PackageCatelog from "../../global/packageCatelog";
import IconTextFeature from "../../global/iconTextFeature";
import LeadershipFeature from "../../global/leadershipFeature";
import ImageShowcase from "../../global/imageShowcase";
import InformationPanel from "../../global/infomationPanel";
import ImageGridRectangular from "../../global/imageGridRectangular";
import ImageGridSquare from "../../global/imageGridSquare";
import PlainRichtext from "../../global/plainRichtext";
import ImageRichtext from "../../global/imageRichtext";
import PartnerShowCase from "../../global/partnerShowCase";
import BusinessServiceShowcase from "../../global/businessServiceShowcase";
import BlogCardsHeader from "../../global/blogCardsHeader";
import ContentCTA from "../../global/contentCTA";
import ContactFormImageV2 from "../../global/contactFormImageV2";
import LocationMapView from "../../global/locationMapView";
import SplashPage from "../../global/splashPage";
import HomePagePresss from "../../global/homepagePress";
import SectionHeadingTitle from "../../global/sectionHeadingTitle";

const renderComponent = (component, i, isHome) => {
  if (component.published === false) return null;

  switch (component.__typename) {
    case "ComponentPageHero":
      return isHome ? null : <HeroMain content={component} key={i} />;
    case "ComponentPageHeader":
      return <Header content={component} key={i} />;
    case "ComponentPageNewService":
      return <NewService content={component} key={i} />;
    case "ComponentPageServiceSlider":
      return <ServicesSlider content={component} key={i} />;
    case "ComponentPageSection":
      return <PageSection component={component} key={i} />;
    case "ComponentPageContactFormGeneric":
      return <PageContactFormGeneric component={component} key={i} />;
    case "ComponentPageMultipleItems":
      return <PageList component={component} key={i} />;
    case "ComponentPageVisualStory":
      return <VisualStory data={component} key={i} />;
    case "ComponentPageListMedia":
      return <Sponsors content={component} key={i} />;
    case "ComponentPageStepScreenshots":
      return <PageStepScreenshots component={component} key={i} />;
    case "ComponentPageServiceRates":
      return <ConsultationRates content={component} key={i} />;
    case "ComponentPagePackages":
      return <StaticPackageDetails content={component} key={i} />;
    case "ComponentPageSubtitle":
      return <Subtitle content={component} key={i} />;
    case "ComponentPageConditionCards":
      return <ConditionCards content={component} key={i} />;
    case "ComponentPageSliderSection":
      return <SliderSection content={component} key={i} />;
    case "ComponentPageHeroSlider":
      return <HeroSlider content={component} key={i} />;
    case "ComponentPageMinistry":
      return <Ministry content={component} key={i} />;
    case "ComponentPageInlineList":
      return <InlineList content={component} key={i} />;
    case "ComponentPageSimpleParagraphs":
      return <SimpleParagraphs content={component} key={i} />;
    case "ComponentPageBlogPostSelector":
      return <NewPopularArticles content={component} key={i} />;
    case "ComponentPageContactForm":
      return <ContactFormChronic content={component} key={i} />;
    case "ComponentPageContactFormV2":
      return <ContactFormChronicV2 content={component} key={i} />;
    case "ComponentPageContactFormEmail":
      return <ContactFormEmail content={component} key={i} />;
    case "ComponentPageContactFormMensHealth":
      return <ContactFormMensHealth content={component} key={i} />;
    case "ComponentPageContactFormImage":
      return <ContactFormImage content={component} key={i} />;
    case "ComponentPageBusinessServiceShowcase":
      return <BusinessServiceShowcase content={component} key={i} />;
    case "ComponentPageContactFormNric":
      return <ContactForm content={component} key={i} />;
    case "ComponentPageContactFormTime":
      return <ContactFormTime content={component} key={i} />;
    case "ComponentPageSectionList":
      return <SectionList content={component} key={i} />;
    case "ComponentPageVaccinesTable":
      return <TableSection content={component} key={i} />;
    case "ComponentPageVaccinationSection":
      return <VaccinationSection content={component} key={i} />;
    case "ComponentPageBenefitsDropdown":
      return <BenefitsDropdown content={component} key={i} />;
    case "ComponentPageChronicCards":
      return <ChronicPackagesDetails content={component} key={i} />;
    case "ComponentPagePackageModules":
      return <PackageModules content={component} key={i} />;
    case "ComponentPagePrivacyPolicy":
      return <Policy content={component} key={i} />;
    case "ComponentPageDropdownDetails":
      return <DropdownDetails content={component} key={i} />;
    case "ComponentPageDownloadMobileApps":
      return <DownloadMobileApps content={component} key={i} />;
    case "ComponentPageMargin":
      return <Margin content={component} key={i} />;
    case "ComponentPageDropdownCards":
      return <DropdownCards content={component} key={i} />;
    case "ComponentPagePartnerCta":
      return <PartnerCta content={component} key={i} />;
    case "ComponentPageServiceShowcase":
      return <ServiceShowcases content={component} key={i} />;
    case "ComponentPageStaffShowcase":
      return <StaffShowcase content={component} key={i} />;
    case "ComponentPageLatestUpdates":
      return <LatestUpdates content={component} key={i} />;
    case "ComponentPageMediaMentions":
      return <MediaMentions content={component} key={i} />;
    case "ComponentPageTripleInfo":
      return <TripleInfo content={component} key={i} />;
    case "ComponentPageGetApp":
      return <GetApp content={component} key={i} />;
    case "ComponentPageCaseStudies":
      return <CaseStudies content={component} key={i} />;
    case "ComponentPageMarquee":
      return (
        <LazyLoadComponent key={i}>
          <Marquee content={component} />
        </LazyLoadComponent>
      );
    case "ComponentPageListImages":
      return <LogoBanner content={component} key={i} />;
    case "ComponentPageServiceBundles":
      return <ServiceBundles content={component} key={i} />;
    case "ComponentPageEntriesSection":
      return <EntriesSection content={component} key={i} />;
    case "ComponentPageDataModule":
      return <DataModule content={component} key={i} />;
    case "ComponentPageArticlesList":
      return <ArticleDataSection content={component} key={i} />;
    case "ComponentPageFeatureSection":
      return <FeatureSection content={component} key={i} />;
    case "ComponentPagePanelsTable":
      return <PanelsTable content={component} key={i} />;
    case "ComponentPageListShowcase":
      return <MobileAppShowcase content={component} key={i} />;
    case "ComponentPageBlogCardsSection":
      return <BlogCardsSection content={component} key={i} />;
    case "ComponentPagePressroomCardsSection":
      return <PressroomCardsSection content={component} key={i} />;
    case "ComponentPageSurveySection":
      return <SurveySection content={component} key={i} />;
    case "ComponentFormJotform":
      return <JotForm content={component} key={i} />;
    case "ComponentPageJoinUs":
      return <JoinUs content={component} key={i} />;
    case "ComponentPageJoinUsV2":
      return <JoinUsV2 content={component} key={i} />;
    case "ComponentPageTypeOfCare":
      return <TypeOfCare content={component} key={i} />;
    case "ComponentPageComponentSplitting":
      return <ComponentSplitting content={component} key={i} />;
    case "ComponentPageImageTextFlexAlign":
      return <ImageTextFlexAlign content={component} key={i} />;
    case "ComponentPageHeroCall":
      return <HeroCall content={component} key={i} />;
    case "ComponentPageHeroForm":
      return <HeroForm content={component} key={i} />;
    case "ComponentPageSymptomSearch":
      return <SymptomSearch content={component} key={i} />;
    case "ComponentPageFaq":
      return <FAQs content={component} key={i} />;
    case "ComponentPageMiniCta":
      return <MiniCta content={component} key={i} />;
    case "ComponentPageDownloadAppV4":
      return <DownloadAppV4 content={component} key={i} />;
    case "ComponentPageHouseCallDoctor":
      return <HouseCallDoctor content={component} key={i} />;
    case "ComponentPageOurServices":
      return <OurServices content={component} key={i} />;
    case "ComponentPageTestimonials":
      return <Testimonials content={component} key={i} />;
    case "ComponentPagePackageCatelog":
      return <PackageCatelog content={component} key={i} />;
    case "ComponentPageTiles":
      return <Tile content={component} key={i} />;
    case "ComponentPageBusinessPartner":
      return <BusinessPartner content={component} key={i} />;
    case "ComponentPageHeroV4":
      return isHome ? null : <HeroComponentV4 content={component} key={i} />;
    case "ComponentPageWhyBookHouseCallDoctor":
      return <WhyBookHouseCallDoctor content={component} key={i} />;
    case "ComponentPageDynamicBookingForm":
      return <DynamicBookingForm content={component} key={i} />;
    case "ComponentPageHeroFlat":
      return <HeroFlat content={component} key={i} />;
    case "ComponentPageArticleListView":
      return <ArticleListView content={component} key={i} />;
    case "ComponentPageAmbulancePartners":
      return <AmbulancePartners content={component} key={i} />;
    case "ComponentPageProgrammeFeature":
      return <ProgrammeFeature content={component} key={i} />;
    case "ComponentPageFeaturedQuote":
      return <FeaturedQuote content={component} key={i} />;
    case "ComponentPageOurPartnersMini":
      return <OurPartnersMini content={component} key={i} />;
    case "ComponentPageFeaturedText":
      return <FeaturedText content={component} key={i} />;
    case "ComponentPageIconTextFeature":
      return <IconTextFeature content={component} key={i} />;
    case "ComponentPageLeadershipFeature":
      return <LeadershipFeature content={component} key={i} />;
    case "ComponentPageImageShowcase":
      return <ImageShowcase content={component} key={i} />;
    case "ComponentPageInformationPanel":
      return <InformationPanel content={component} key={i} />;
    case "ComponentPageImageGridRectangular":
      return <ImageGridRectangular content={component} key={i} />;
    case "ComponentPageImageGridSquare":
      return <ImageGridSquare content={component} key={i} />;
    case "ComponentPageContactFormImageV2":
      return <ContactFormImageV2 content={component} key={i} />;
    case "ComponentPagePlainRichtext":
      return <PlainRichtext content={component} key={i} />;
    case "ComponentPageImageRichtext":
      return <ImageRichtext content={component} key={i} />;
    case "ComponentPagePartnerShowCase":
      return <PartnerShowCase content={component} key={i} />;
    case "ComponentPageBlogCardsHeader":
      return <BlogCardsHeader content={component} key={i} />;
    case "ComponentPageLocationMapView":
      return <LocationMapView content={component} key={i} />;
    case "ComponentPageContentCta":
      return <ContentCTA content={component} key={i} />;
    case "ComponentPageSplashPage":
      return <SplashPage content={component} key={i} />;
    case "ComponentPageHomepagePress":
      return <HomePagePresss content={component} key={i} />;
    case "ComponentPageSectionHeading":
      return <SectionHeadingTitle content={component} key={i} />;
    default:
      return null;
  }
};

export default function PageComponent({ components, isHome }) {
  return <>{components.map((c, i) => renderComponent(c, i, isHome))}</>;
}
